module.exports = __webpack_public_path__ + "img/berichte-active.19c4d9d9.svg";